import TagManager from 'react-gtm-module';

const trackBazaarvoiceEvent = (interactionLocation: string) => {
  TagManager.dataLayer({ dataLayer: { ecommerce: null } });
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_review',
      interaction: {
        interaction_location: interactionLocation,
      },
    },
  });
};

export default trackBazaarvoiceEvent;
